import {
  Arrange,
  Container,
  Icon,
  IconButton,
  Spacer,
  SvgClose,
  SvgSparkle,
  Text,
} from '@loomhq/lens';
import React from 'react';

import styles from './styles.module.less';

const TrimFtuxTooltip = ({
  show,
  dismissTooltip,
}: {
  show: boolean;
  dismissTooltip: () => void;
}): JSX.Element | null => {
  if (!show) {
    return null;
  }

  const handleClick = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    dismissTooltip();
  };

  return (
    <Container
      position="relative"
      backgroundColor="discoveryLightBackground"
      padding="medium"
      borderColor="blue"
      borderSide="all"
      radius="medium"
      borderWidth="2px"
      className={styles.ftuxContainer}
    >
      <Container position="absolute" top={0} right={0}>
        <IconButton
          icon={<SvgClose />}
          size="small"
          onClick={handleClick}
          altText="close"
        />
      </Container>
      <Container paddingRight="small">
        <Arrange gap="xsmall">
          <Icon size={2} icon={<SvgSparkle />} color="discoveryTitle" />
          <Text size="small" fontWeight="bold" color="discoveryTitle">
            New! Faster, easier trimming
          </Text>
        </Arrange>
      </Container>
      <Spacer top="medium">
        <Text size="small" color="body">
          Make quick edits with a redesigned and more efficient trimming
          experience.
        </Text>
      </Spacer>
    </Container>
  );
};

export default TrimFtuxTooltip;
